import { memo, type ReactNode } from 'react';

type GalleryCardImageWrapperProps = {
  children?: ReactNode;
};

export const GalleryCardImageWrapper = memo(({ children }: GalleryCardImageWrapperProps) => (
  <div className="pointer-events-none absolute inset-0 overflow-hidden rounded-4">
    {children}
    <div className="absolute inset-0 bg-gradient-to-t from-20% from-black/60 to-black/20" />
  </div>
));

GalleryCardImageWrapper.displayName = 'GalleryCardImageWrapper';
